import React, { useEffect, useRef, useState } from 'react'
import { Box, Grid, TextField, Tooltip, Zoom } from '@mui/material'
import { styled } from '@mui/material/styles'
import { makeStyles } from '@material-ui/core/styles'
import ImageCar from 'src/assets/Buy_Policy_Images/KuttiCar.svg'
import ImageCorrectCar from 'src/assets/Buy_Policy_Images/CorrectCar.svg'
import {
  INVALID_LICENSE,
  MOTOR_OPTIONS_LIST,
  NICKNAME,
  POLICY_TYPES,
  VALID_VEHICLE_NUMBER,
  VALID_VH_NUMBER,
  VEHICLE_DETAILS,
} from 'src/utils/constants/BuyPolicy'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import InputAdornment from '@mui/material/InputAdornment'
import MotorDialog from 'src/components/BuyPolicy/insuranceScreens/motor/MotorDialog'
import Features from 'src/components/BuyPolicy/insuranceScreens/motor/Features'
import {
  VEHICLE_NUMBER_REGEX,
  vehicleType,
} from 'src/utils/constants/BuyPolicyMotor'
import { Button } from '@material-ui/core'
import {
  showNotificationMessage,
  updateIsVehiclePrefilledData,
  updateMotorDetails,
  updatePersonalDetailsMotor,
  updatePreviousPolicyDetailsMotor,
  updateTokenMotor,
  updateVehicleDetailsMotor,
} from 'src/actions'
import NoPreFilledData from './NoPrefilledDataModal'
import { useDispatch, useSelector } from 'react-redux'
import { addScroll, removeScroll, removeSpaces } from 'src/utils/commonMethods'
import Modal from '@mui/material/Modal'
import BuyCarInsuranceModal from './BuyCarInsuranceModal/BuyCarInsuranceModal'
import TrovityContent from 'src/components/BuyPolicy/insuranceScreens/motor/TrovityContent'
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt'
import { verifyMotorDetails } from 'src/services/buyPolicyMotorService'
import LoadingModal from 'src/components/common/LoadingModal'
import { getTokenForQrReport } from 'src/services/individualService'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { useHistory } from 'react-router-dom'
import {
  VEHICLE_TYPE,
  VEHICLE_TYPE_TEXT,
} from 'src/utils/constants/BuyPolicyBike'
import VehicleInformationModal from 'src/components/BuyPolicy/common/VehicleInformationModal'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'

const SectionContainer = styled('div')(() => ({
  flexGrow: 1,
  width: '100%',
}))

const Motor = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const motorDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const vehicleDetail = motorDetails?.vehicleDetails
  const personalDetails = motorDetails?.personalDetails
  const previousPolicyDetails = motorDetails?.previousPolicyDetails
  const currentPolicyDetails = motorDetails?.currentPolicyDetails
  const fullVehicleDetail = useSelector((state) => state?.buyPolicyMotorReducer)
  const [open, setOpen] = useState(false)
  const [vehicleDetails, setVehicleDetails] = useState({})
  const [isInsuranceModalOpen, setIsInsuranceModalOpen] = useState(false)
  const [buyInsuranceType, setBuyInsuranceType] = useState(null)
  const [showNext, setShowNext] = useState(false)
  const [isNickNameFieldActive, setIsNickNameFieldActive] = useState(false)
  const vehicleNumberRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false)
  const [showVehicalInformation, setShowVehicalInformation] = useState(false)

  const handleVehicleDetails = (e) => {
    setVehicleDetails({
      ...vehicleDetails,
      [e.target.name]: e?.target?.value,
    })

    if (e?.target?.name === NICKNAME) {
      setShowNext(true)
    }
  }
  const handleNext = () => {
    vehicleNumberRef.current.focus()
  }
  const formatLicensePlate = (licensePlate) => {
    if (typeof licensePlate !== 'string' || licensePlate?.length < 8) {
      return INVALID_LICENSE
    }
    licensePlate = licensePlate?.toUpperCase()
    const part1 = licensePlate?.slice(0, 4)
    const part2 = licensePlate?.slice(4, 6)
    const part3 = licensePlate?.slice(6)
    return `${part1}${part2}${part3}`
  }
  const handleNickNameFocus = () => {
    setIsNickNameFieldActive(true)
  }
  const handleNickNameBlur = () => {
    setIsNickNameFieldActive(false)
  }

  const validateVehicleNumber = (vehicleNumber) => {
    return VEHICLE_NUMBER_REGEX?.test(vehicleNumber)
  }

  const handleOpenDialog = async () => {
    if (vehicleDetails?.vehicleNumber) {
      if (!validateVehicleNumber(vehicleDetails?.vehicleNumber)) {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: VALID_VEHICLE_NUMBER,
          })
        )
      } else {
        fetchToken()
      }
    } else {
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: VALID_VH_NUMBER,
        })
      )
    }
  }

  const fetchToken = async () => {
    setLoading(true)
    const response = await getTokenForQrReport()

    try {
      if (response?.res?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success

      setLoading(false)
      const token = response?.res?.data?.access_token
      dispatch(updateTokenMotor(token))

      getVehicleDetailsFromSingzy(token, vehicleDetails?.vehicleNumber)
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }

  const getVehicleDetailsFromSingzy = async (token, vehicleNumber) => {
    setLoading(true)
    try {
      const response = await verifyMotorDetails(token, vehicleNumber)

      if (response?.status !== 200) {
        setLoading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
        setIsErrorModalOpen(true)
      } else {
        // Success
        setLoading(false)

        const responseData = response?.data
        if (responseData?.success) {
          if (responseData?.vehicleType === VEHICLE_TYPE?.TWO_WHEELER) {
            setShowVehicalInformation(true)
          } else {
            setOpen(true)
            dispatch(updateIsVehiclePrefilledData(true))
            const vehicleDetailsMotor = {
              ...vehicleDetail,
              chassisNumber: responseData?.chassis,
              engineNumber: responseData?.engine,
              vehicleNumber: formatLicensePlate(vehicleDetails?.vehicleNumber),
              nickName: vehicleDetails?.nickName,
              brand: {
                genericName: responseData?.vehicleManufacturerFirstName,
              },
              vehicleLogo: responseData?.vehicleMakeLogo,
              model: { modelGenericName: responseData?.model || '' },
              yearOfManufacturer: responseData?.manufacturingYear || '',
              monthOfManufacturer: responseData?.manufacturingMonth || '',
              regDate: responseData?.regDate,
              vehicleSubmit: true,
              fuelType: { genericName: responseData?.fuel },
            }
            dispatch(updateVehicleDetailsMotor(vehicleDetailsMotor))

            const previousPolicyDetailsMotor = {
              ...fullVehicleDetail.previousPolicyDetails,
              previousPolicyProvider: {
                insuranceCompanyName: responseData?.vehicleInsuranceCompanyName,
                insuranceCompanyFirstName:
                  responseData?.insuranceCompanyFirstName,
              },
              previousPolicyNumber: responseData?.vehicleInsurancePolicyNumber,
              isPolicyExpired: responseData?.vehicleInsuranceExpired
                ? POLICY_TYPES?.EXPIRED
                : POLICY_TYPES?.NOT_EXPIRED,
              expiryDate: !responseData?.vehicleInsuranceExpired
                ? responseData?.vehicleInsuranceUpto
                : '',
              expiredDate: responseData?.vehicleInsuranceExpired
                ? responseData?.vehicleInsuranceUpto
                : '',
            }

            dispatch(
              updatePreviousPolicyDetailsMotor(previousPolicyDetailsMotor)
            )
            dispatch(
              updatePersonalDetailsMotor({
                ...fullVehicleDetail?.personalDetails,
                pincode: responseData?.pincode,
                city: responseData?.city,
                state: responseData?.state,
                fullAddress: responseData?.address,
              })
            )
          }
        } else {
          setLoading(true)
          setIsErrorModalOpen(true)
          dispatch(
            showNotificationMessage({
              type: NOTIFICATION_TYPES.ERROR,
              message: responseData?.message,
            })
          )
          dispatch(
            updateVehicleDetailsMotor({
              ...vehicleDetail,
              vehicleNumber: formatLicensePlate(vehicleDetails?.vehicleNumber),
              nickName: vehicleDetails?.nickName,
            })
          )
          setLoading(false)
        }
      }
    } catch (err) {
      setLoading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: VEHICLE_DETAILS,
        })
      )
    }
  }

  const handlePrefillData = () => {
    setVehicleDetails({
      vehicleNumber: removeSpaces(vehicleDetail?.vehicleNumber),
      nickName: vehicleDetail?.nickName,
    })
  }

  useEffect(() => {
    handlePrefillData()
    if (vehicleDetail?.regDate) {
      setOpen(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const toggleBuyInsuranceModalOpen = (isOpen = false, type = null) => {
    setIsInsuranceModalOpen(isOpen)
    setBuyInsuranceType(type)
  }

  const handleSubmit = async (values, setSubmitting) => {
    setSubmitting(true)
    if (
      window.location.pathname ===
      '/individual/dashboard/buyPolicy/motor/insuranceDetails'
    ) {
      handleDispatches(values)
      handleClose()
    } else {
      handleDispatches(values)
      handleClose()
      history.push('/individual/dashboard/buyPolicy/motor/insuranceDetails')
    }
  }
  const handleDispatches = (values) => {
    dispatch(
      updateMotorDetails({
        vehicleDetails: {
          ...vehicleDetail,
          isCompany: values?.isCompany,
          companyName: values?.companyName,
        },
        personalDetails: {
          ...personalDetails,
          name: values?.name,
          mobileNumber: values?.mobileNumber,
          email: values?.email,
        },
        previousPolicyDetails: {
          ...previousPolicyDetails,
          previousPolicyProvider: {
            ...previousPolicyDetails.previousPolicyProvider,
            insuranceCompanyName: values?.previousPolicyProvider,
            insuranceCompanyFirstName: values?.previousPolicyProviderFirstName,
          },
          previousPolicyNumber: values?.previousPolicyNumber,
          existingPolicyClaim: values?.existingPolicyClaim,
          ncb: values?.ncb,
          isPolicyExpired: values?.isPolicyExpired,
          expiryDate: values?.expiryDate,
          expiredDate: values?.expiredDate,
          isPolicyExpiredBeforeDate: values?.isPolicyExpiredBeforeDate,
          thirdPartyExpiryDate: values?.thirdPartyExpiryDate,
          thirdPartyPolicyNo: values?.thirdPartyPolicyNo,
          thirdPartyStartDate: values?.thirdPartyStartDate,
          thirdPartyProvider: values?.thirdPartyProvider,
          thirdPartyProviderFirstName: values?.thirdPartyProviderFirstName,
        },
        currentPolicyDetails: {
          ...currentPolicyDetails,
          policyType: values?.policyType,
        },
      })
    )
  }
  const handleClose = () => {
    setOpen(false)
  }

  const handleTwoWheeler = () => {
    history.push('/individual/dashboard/buyPolicy/bike')
  }

  useEffect(() => {
    if (isInsuranceModalOpen) {
      removeScroll()
    } else {
      addScroll()
    }
  }, [isInsuranceModalOpen])
  return (
    <>
      <LoadingModal loading={loading} />
      <SectionContainer>
        {open ? (
          <MotorDialog
            open={open}
            setOpen={setOpen}
            handleSubmit={handleSubmit}
          />
        ) : null}
        {showVehicalInformation ? (
          <VehicleInformationModal
            open={showVehicalInformation}
            setOpen={setShowVehicalInformation}
            buyType={VEHICLE_TYPE_TEXT?.FOUR_WHEELER}
            vehicleType={VEHICLE_TYPE_TEXT?.TWO_WHEELER}
            handleClick={handleTwoWheeler}
          />
        ) : null}
        {isErrorModalOpen ? (
          <Modal
            open={isErrorModalOpen}
            onClose={() => setIsErrorModalOpen(false)}
            id='errorModal'
          >
            <div className={'modal-container'}>
              <NoPreFilledData
                handleClose={() => setIsErrorModalOpen(false)}
                number={vehicleDetails?.vehicleNumber}
                vehicleType={vehicleType?.FOUR_WHEELER}
              />
            </div>
          </Modal>
        ) : null}

        {isInsuranceModalOpen ? (
          <Modal
            open={isInsuranceModalOpen}
            onClose={() => toggleBuyInsuranceModalOpen(false)}
            id='modal'
          >
            <div className={'modal-container'}>
              <BuyCarInsuranceModal
                isInsuranceModalOpen={isInsuranceModalOpen}
                buyInsuranceType={buyInsuranceType}
                handleClose={() => toggleBuyInsuranceModalOpen(false)}
              />
            </div>
          </Modal>
        ) : null}

        <Grid container spacing={0} direction='column'>
          <Grid item xs={12}>
            <Box className={classes.vehicleDetailsSection}>
              <Box className={classes.vehicleDetailsSectionContent}>
                <Box className={classes.nickNameContainer}>
                  <Box>
                    <Box className={classes.bannerTextOne}>
                      Insure the Emotion,
                    </Box>
                    <Box className={classes.bannerTextTwo}>
                      Safeguard Your Vehicle Like Family.
                    </Box>
                  </Box>
                  <Box className={classes.nickNameImageSection}>
                    <Box>
                      <img
                        src={ImageCar}
                        width={'274px'}
                        height={'173px'}
                        alt='Kutti-car'
                      />
                    </Box>
                    <Box mb={5}>
                      <Box className={classes.nickNameText}>
                        <Box ml={2} className={classes.bannerTextFour}>
                          Has Your Vehicle
                        </Box>
                        <Box ml={5}>
                          <span className={classes.bannerTextFour}>
                            Earned a
                          </span>{' '}
                          <span className={classes.bannerTextFive}>
                            Nickname?
                          </span>
                        </Box>
                      </Box>
                      <Box className={classes.nickNameNextContainer}>
                        <TextField
                          id='nickName'
                          name='nickName'
                          size={'small'}
                          className={`${classes.bannerTextFieldOne} ${classes.bannerField}`}
                          placeholder={'KUTTI, BumbleBee, Banti-Puvvu'}
                          onFocus={handleNickNameFocus}
                          onBlur={handleNickNameBlur}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position='end'>
                                <CheckCircleIcon
                                  className={
                                    vehicleDetails?.nickName?.length > 0
                                      ? classes.nickNameActive
                                      : classes.nickNameColor
                                  }
                                />
                              </InputAdornment>
                            ),
                          }}
                          value={vehicleDetails?.nickName}
                          onChange={handleVehicleDetails}
                        />
                        {showNext && (
                          <Box onClick={handleNext} className={classes.skipBtn}>
                            <ArrowRightAltIcon />
                          </Box>
                        )}
                      </Box>
                    </Box>
                  </Box>
                  <Box className={classes.bannerTextThree}>
                    Spill the Auto-motional Secrets
                  </Box>
                </Box>
                <Box className={classes.BuyCarContainer}>
                  <Box className={classes.flexContainerRow}>
                    <Box className={classes.imageAction}>
                      <img src={ImageCorrectCar} alt='check-car' />
                    </Box>
                    <Box>
                      <Box>
                        <span className={classes.buyContent}>Buy</span>{' '}
                        <span className={classes.carContent}>Car</span>
                      </Box>
                      <Box className={classes.carContent}>Insurance</Box>
                    </Box>
                  </Box>
                  <Box className={classes.vehicleContainer}>
                    <Box className={classes.vehicleTextContainer}>
                      <TextField
                        size='small'
                        name='vehicleNumber'
                        placeholder='Enter your vehicle number'
                        value={vehicleDetails?.vehicleNumber}
                        onChange={handleVehicleDetails}
                        className={`${classes.vehicleField} ${classes.vehicleFieldBox}`}
                        inputRef={vehicleNumberRef}
                        InputProps={{
                          className: classes.vehicleField,
                        }}
                      />
                    </Box>
                    <Box>
                      <Button
                        variant='contained'
                        onClick={handleOpenDialog}
                        className={
                          isNickNameFieldActive
                            ? classes.secureBtnNickNameActive
                            : classes.secureBtn
                        }
                        id='secureButton'
                      >
                        SECURE {vehicleDetails?.nickName || ''}
                      </Button>
                    </Box>
                  </Box>

                  <Box>
                    <Box className={classes.optionsContainer}>
                      {MOTOR_OPTIONS_LIST?.map(
                        (otherOptionsListItem, index) => {
                          return (
                            <Box
                              key={otherOptionsListItem?.type}
                              id={`otherOptionsListItem_${index}`}
                              className={classes.otherOption}
                            >
                              <span className={classes.optionDescription}>
                                {otherOptionsListItem?.description}
                              </span>
                              <Tooltip
                                TransitionComponent={Zoom}
                                placement='bottom'
                                title={'Coming Soon'}
                                arrow
                              >
                                <span
                                  className={classes.optionLabel}
                                  // onClick={() =>
                                  //   todo:  Need to implement this once master data is finalised
                                  //   toggleBuyInsuranceModalOpen(true, otherOptionsListItem.type)
                                  // }
                                >
                                  {otherOptionsListItem?.label}
                                </span>
                              </Tooltip>
                            </Box>
                          )
                        }
                      )}
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid xs={12}>
            <Box className={classes.motorAnimationSection}>
              <iframe
                src='https://paisaplan.s3.ap-south-1.amazonaws.com/public/animations/buyPolicy/motor/data.html'
                frameBorder='0'
                allowFullScreen
                className={classes.motorAnimationContainer}
              />
            </Box>
            <Box className={classes.featuresSection}>
              <TrovityContent />
              <Features />
            </Box>
          </Grid>
        </Grid>
      </SectionContainer>
    </>
  )
}

export default Motor

const useStyles = makeStyles({
  vehicleDetailsSection: {
    background: 'linear-gradient(180deg, #DFF7FF 4.08%, #FFFFFF 102.47%)',
    backgroundSize: '100% 50%',
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#FFFFFF',
    paddingTop: 30,
  },
  vehicleDetailsSectionContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 23,
    flexWrap: 'wrap',
    position: 'relative',
    zIndex: 2,
    width: '100%',
    gap: 30,
  },
  vehicleFieldBox: {
    '& .MuiInputBase-input': {
      textTransform: 'uppercase !important',
    },
  },
  nickNameContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    gap: 15,
    marginLeft: '-20px',
    paddingRight: 10,
  },
  BuyCarContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 30,
  },
  flexContainerColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  flexContainerRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
  },
  optionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    gap: '15px',
    flexWrap: 'wrap',
  },
  otherOption: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background:
      'linear-gradient(180deg, rgba(124, 173, 196, 0.2) 0%, rgba(255, 255, 255, 0) 100%)',
    padding: '20px 40px',
    borderRadius: '10px',
    gap: '5px',
    flexWrap: 'wrap',
  },
  optionDescription: {
    fontSize: '12px',
    color: '#2E3F44',
  },
  optionLabel: {
    fontSize: '15px',
    fontWeight: 'bold',
    color: '#2A90BC',
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  motorAnimationSection: {
    zIndex: 1,
    width: '100%',
    marginTop: '-12%',
    '@media (min-width: 1460px)': {
      marginTop: '-5%',
    },
  },
  bannerTextOne: {
    fontFamily: 'Roboto',
    fontWeight: 300,
    fontSize: '30px',
    lineHeight: '35.16px',
    color: '#000000',
    letterSpacing: '0em',
  },
  bannerTextTwo: {
    fontFamily: 'Roboto',
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '21px',
    letterSpacing: '0em',
    color: '#2AA4C5',
    marginLeft: 70,
  },
  bannerTextThree: {
    fontFamily: 'Rochester',
    fontSize: '25px',
    fontWeight: 400,
    lineHeight: '32px',
    letterSpacing: '0.055em',
    textAlign: 'center',
    color: '#ADADAD',
    marginLeft: '12.7vw',
    marginTop: '-2.2vw',
  },
  bannerTextFour: {
    fontFamily: 'Roboto',
    fontSize: '15px',
    fontWeight: 400,
    lineHeight: '17.58px',
    letterSpacing: '0em',
    color: '#000000',
  },
  bannerTextFive: {
    fontFamily: 'Roboto',
    fontSize: '15px',
    fontWeight: 400,
    lineHeight: '17.58px',
    letterSpacing: '0em',
    color: '#EF669B',
  },
  bannerTextFieldOne: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#EF669B',
        borderWidth: '1px',
      },
      '&:hover fieldset': {
        borderColor: '#EF669B',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#EF669B',
      },
      fontFamily: 'Roboto, sans-serif',
      fontSize: '13px',
      fontStyle: 'italic',
      fontWeight: 400,
      lineHeight: '15px',
      letterSpacing: '0em',
      textAlign: 'center',
      width: '255px',
    },
  },
  secureBtn: {
    background: 'linear-gradient(180deg, #4DC3E3 0%, #1EA0C4 100%)',
    height: '30px',
    fontSize: '12px',
    padding: '17px 30px 15px 30px',
    color: '#FFFFFF',
  },
  secureBtnNickNameActive: {
    background: 'linear-gradient(180deg, #EF669B 0%, #EF669B 100%)',
    height: '30px',
    fontSize: '12px',
    padding: '17px 30px 15px 30px',
    color: '#FFFFFF',
  },
  bannerField: {
    '& .MuiInputBase-input': {
      textTransform: 'capitalize !important',
    },
  },
  buyContent: {
    fontFamily: 'Roboto',
    fontSize: '21px',
    fontWeight: 500,
    color: '#2EA9CA',
  },
  carContent: {
    fontFamily: 'Roboto',
    fontSize: '21px',
    fontWeight: 500,
  },
  imageAction: {
    paddingTop: '5%',
  },
  featuresSection: {},
  motorAnimationContainer: {
    height: '360px',
    width: '100%',
  },
  nickNameColor: {
    color: '#EF669B',
    opacity: 0.3,
    marginRight: '-8px',
  },
  nickNameActive: {
    color: '#EF669B',
    marginRight: '-8px',
  },
  vehicleContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: 10,
    marginTop: '-10px',
  },
  vehicleField: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderWidth: '1px',
      },
      '&:hover fieldset': {
        borderColor: '#4DC3E3',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#4DC3E3',
      },
      fontFamily: 'Roboto, sans-serif',
      fontSize: '13px',
      fontStyle: 'italic',
      fontWeight: 400,
      lineHeight: '15px',
      letterSpacing: '0em',
      textAlign: 'center',
      width: '255px',
      background: '#FFFFFF',
      textTransform: 'capitalize',
    },
  },
  nickNameImageSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 15,
  },
  vehicleTextContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  skipBtn: {
    fontSize: '12px',
    padding: '0px',
    color: '#EF669B',
    marginLeft: 'auto',
    cursor: 'pointer',
  },
  highlight: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#EF669B',
        borderWidth: '1px',
        boxShadow: '0 0 5px #EF669B',
      },
      '&:hover fieldset': {
        borderColor: '#EF669B',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#EF669B',
      },
      fontFamily: 'Roboto, sans-serif',
      fontSize: '13px',
      fontStyle: 'italic',
      fontWeight: 400,
      lineHeight: '15px',
      letterSpacing: '0em',
      textAlign: 'center',
      width: '255px',
    },
  },
  nickNameNextContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
})
